import { useCallback, useState } from "react";
import axios from "axios";
import { useDigitalPassController } from "context";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

const api = process.env.REACT_APP_API_URL;

//sesiionfrom context
const useAxios = () => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(true);
  const [controller] = useDigitalPassController();
  const { session } = controller;
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();
  const get = useCallback(
    async (path, customHeader = {}) => {
      const instance = axios.create({
        baseURL: api,
        timeout: 30000,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${session}`,
          ...customHeader,
        },
      });
      setGetLoading(true);
      try {
        const response = await instance.get(path);
        if (response.data.status === 401) {
          enqueueSnackbar(response.data.message, { variant: "error" });
          navigate("/auth/logout");
          // return;
        }
        setGetLoading(false);
        return response.data;
      } catch (err) {
        console.log(new Date().toLocaleString(), "Error in Get Axios : ", err);
        setGetLoading(false);
        throw new Error(err.message || "Something went Wrong!");
      }
    },
    [session, navigate, enqueueSnackbar]
  );

  const post = useCallback(
    async (path, payload, customHeader, responseType = null) => {
      const instance = axios.create({
        baseURL: api,
        withCredentials: true,
        ...(responseType ? { responseType: responseType } : {}),
        headers: {
          Authorization: `Bearer ${session}`,
          ...customHeader,
        },
      });

      try {
        setPostLoading(true);
        const response = await instance.post(path, payload);
        if (response.data.status === 401) {
          enqueueSnackbar(response.data.message, { variant: "error" });
          navigate("/auth/logout");
          // return;
        }
        setPostLoading(false);
        return response.data;
      } catch (err) {
        console.log(new Date().toLocaleString(), "Error in Post Axios : ", err);
        setPostLoading(false);
        throw new Error(err.message || "Something went Wrong!");
      }
    },
    [session, navigate, enqueueSnackbar]
  );
  return {
    get,
    post,
    getLoading,
    postLoading,
    setPostLoading,
    setGetLoading,
  };
};

export default useAxios;
